import { Icon } from '@coop/components';
import { Info1Icon } from '@coop/icons';

import styles from './MissingItemBody.module.scss';

const MissingItemInfo = (props: { text: string }) => {
    return (
        <div className={styles.MissingItemInfo}>
            <Icon icon={Info1Icon} width={16} height={16} aria-hidden />
            <span>{props.text}</span>
        </div>
    );
};

export default MissingItemInfo;
